module.exports = __webpack_public_path__ + "img/bim (5).bc863f74.png";